import { render, staticRenderFns } from "./Repetirdia.vue?vue&type=template&id=1c822f13&scoped=true&"
import script from "./Repetirdia.vue?vue&type=script&lang=ts&"
export * from "./Repetirdia.vue?vue&type=script&lang=ts&"
import style0 from "./Repetirdia.vue?vue&type=style&index=0&id=1c822f13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c822f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c822f13', component.options)
    } else {
      api.reload('1c822f13', component.options)
    }
    module.hot.accept("./Repetirdia.vue?vue&type=template&id=1c822f13&scoped=true&", function () {
      api.rerender('1c822f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/RepetirDia/Repetirdia.vue"
export default component.exports